/** Map pdf-lib WinAnsi encode failures to an actionable user message. */
export function friendlyPdfErrorMessage(message: string): string {
  const raw = String(message || "");
  const m = raw.match(/cannot encode "(.+?)" \((0x[0-9a-f]+)\)/i);
  if (!m) return raw;
  const ch = m[1];
  const hex = m[2].toLowerCase();
  return (
    `The character “${ch}” (Unicode ${hex}) isn’t supported on invoices. ` +
    `Replace it with a regular hyphen (-) or plain text, then try again.`
  );
}

export function isPdfEncodeError(message: string): boolean {
  const raw = String(message || "");
  return (
    /cannot encode ".+?" \(0x[0-9a-f]+\)/i.test(raw) ||
    /isn’t supported on invoices/i.test(raw)
  );
}
